<div class="folder-menu">
  @if (!searchMode) {
    <div class="folder-menu-header all-galleries">
      @if (currentFolder) {
        <button
          appButton
          name="move-to-level-up"
          location="finder"
          [iconButton]="true"
          color="hard-simple"
          height="1"
          (click)="upFolder()"
          spacing="full"
          shape="small"
        >
          <app-svg src="/assets/icons/arrow-left.svg"></app-svg>
        </button>
        <app-svg src="/assets/icons/folder.svg"></app-svg>
        <span>{{ currentFolder.title }}</span>
      } @else {
        <span>All Galleries</span>
      }
      <div class="spacer"></div>
      <button
        appButton
        name="search"
        height="1"
        shape="round"
        location="finder"
        [iconButton]="true"
        color="simple-gray"
        (click)="enableSearchMode()"
      >
        <app-svg src="/assets/icons/search.svg"></app-svg>
      </button>
      <app-context-menu
        [options]="{ width: '240px', noSpacing: true }"
        data-test-id="create-more"
        position="right"
        #createMenu
      >
        <button
          appButton
          name="more"
          location="finder"
          height="1"
          shape="round"
          [iconButton]="true"
          color="simple-gray"
          contextButton
        >
          <app-svg src="/assets/icons/dots-vertical.svg"></app-svg>
        </button>
        <div class="button-menu" contextContent>
          @if (createMenu.isOpen) {
            <app-create-gallery-context
              [folder]="currentFolder"
              [reOpenFn]="reOpenFn"
              [showDialogForGalleryCreation]="true"
              (onClose)="createMenu.close()"
            >
            </app-create-gallery-context>
          }
        </div>
      </app-context-menu>
    </div>
  }
  @if (searchMode) {
    <div class="search-header" [formGroup]="searchForm">
      <app-input-field
        [control]="searchForm.controls.search"
        [big]="true"
        [noLabel]="true"
        [bottomFlat]="true"
        [bigish]="true"
        class="headless"
      >
        <app-svg src="/assets/icons/search.svg" *appInputPre></app-svg>
        <input formControlName="search" #searchField />
      </app-input-field>
      <button
        appButton
        name="close-search"
        location="finder"
        shape="round"
        height="1"
        [iconButton]="true"
        color="simple-gray"
        (click)="disableSearchMode()"
      >
        <app-svg src="/assets/icons/cross.svg"></app-svg>
      </button>
    </div>
  }
  <div class="folder-menu-content" [class.block-galleries]="blockGallerySelection" (click)="selectGallery(undefined)">
    @if (noResults) {
      <div class="no-folders">
        @if (!searchMode) {
          <span>Empty</span>
        }
        @if (searchMode) {
          <span>No Results</span>
        }
      </div>
    }
    <app-finder-content
      #finderContent
      (onSelectFolder)="selectFolder($event)"
      (onSelectGallery)="selectGallery($event)"
      (onResultsUpdated)="noResults = !$event.length"
      [allGalleries]="allGalleries"
      [allFolders]="allFolders"
      [currentFolder]="currentFolder"
      [currentGallery]="currentGallery"
      [searchMode]="searchMode"
      [searchTerm]="searchTerm"
      [filterOut]="filterOut"
      [disableList]="disableList"
      [blockGallerySelection]="blockGallerySelection"
      [hideSubGalleries]="hideSubGalleries"
    ></app-finder-content>
  </div>
</div>
